<template>
  <header :class="top != 0 ? 'active' : ''">
    <div class="header total-width">
      <!--自己找张图片做10g0-->
      <router-link class="logo" to="index"
        ><img src="../assets/images/logo.png" />
      </router-link>

      <nav @mouseleave="elHandle">
        <router-link
        class="relative nav-item"
          :to="item.link"
          active-class="actived"
          v-for="item in oList"
          :key="item.id"
          @mouseover.native="selectHandle(item.id)"
          >
          {{ item.title }}
          <transition name="expand">
            <div class="second_menu" @mouseleave="elHandle" v-show="currentId === item.id && currentData.length">
              <div v-for="i in currentData" :key="i.id" class="menu_item">
                <router-link :to="i.link">
                  {{ i.cTitle }}
                </router-link>
              </div>
            </div>
          </transition>
        </router-link>
        <a class="last actived" @mousemove="selectHandle('')">
          <img src="../assets/images/phone.png" alt="" />
          <p>400 6529 888</p>
        </a>
      </nav>
    </div>
  </header>
</template>
<script>
import { headerData } from '@/common/util/data.js'
export default {
  props: {
    top: {
      defalut: 0,
      type: Number,
    },
  },
  data() {
    return {
      ...headerData,
      currentData: [],
      currentId: null,
    }
  },
  components: {
  },
  mounted() {
    this.$refs.secondRef.$el.addEventListener('mouseleave', this.elHandle)
  },
  methods: {
    selectHandle(id) {
      const curActiveData = this.hList.find((item) => item.id === id)
      this.currentId = id
          this.currentData = curActiveData.list || []
    },
    elHandle() {
      this.currentData = []
    },
  },
}
</script>
<style lang="less" scoped>
header {
  width: 100%;
  background: rgba(255, 255, 255, 0.8);
  height: 80px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  backdrop-filter: blur(15px);
  .header {
    height: 100%;
    position: relative;
    z-index: 999;
    display: flex;
    margin: 0 auto;
    align-items: center;
    justify-content: space-between;
    .logo {
      display: inline-block;
      width: 181px;
      height: 34px;
      line-height: 80px;
      img {
        height: 100%;
        width: 100%;
      }
    }
    nav {
      display: flex;
      width: 80%;
      height: 100%;
      align-items: center;
      justify-content: space-between;
      .nav-item {
        position: relative;
      }
      .nav-item, .nav-item:visited {
        display: flex;
        text-align: center;
        color: #111111;
        font-size: 16px;
      }
      .nav-item:hover,
      .nav-item.actived {
        color: #cd3324 !important;
        font-weight: bold;
      }
      .second_menu {
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 217%;
        left: 50%;
        transform: translateX(-50%);
        background: #ffffff;
        padding: 15px 30px;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.06);
        white-space: nowrap;
        z-index: 1000;
        color: #666;
        .menu_item {
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
          &:hover {
            color: #111;
          }
          a {
            display: block;
            text-align: left;
            padding: 5px 0;
          }
        }
      }
    }
  }
}
header.active {
  background-color: #fff;
  box-shadow: inset 0 -1px 0 0 #e6ebf2;
}
.last {
  height: 100%;
  display: flex;
  align-items: center;
  img {
    width: 20px;
    height: 20px;
    margin-top: -3px;
    margin-right: 10px;
  }
  p {
    color: #333333;
    font-weight: bold;
  }
}
</style>
